import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import VueGtm from 'vue-gtm';
import VueIntercom from 'vue-intercom';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import App from './App.vue';
import router from './router';
import store from './store';
import CallAPI from './plugins/CallAPI';
import './plugins/VeeValidate';
import './plugins/Notifications';
import './plugins/GlobalComponents';

Sentry.init({
	dsn: 'https://1c7a21b31c54315045c905fe35a21e2a@o4509711156707333.ingest.de.sentry.io/4509807414542416',
	integrations: [
		new VueIntegration({
			Vue,
			tracing: true,
		}),
		new Integrations.BrowserTracing(),
	],
	tracesSampleRate: 1,
	environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
	release: process.env.VUE_APP_SENTRY_RELEASE,
});

Vue.config.productionTip = false;

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.use(VueGtm, {
	id: 'GTM-KSD3CFT',
	enabled: true,
	debug: false,
	vueRouter: router,
});

Vue.use(CallAPI);

Vue.use(VueIntercom, { appId: 'g21s2k3x' });

window.onunhandledrejection = () => {
	Vue.notify({
		duration: 6000,
		type: 'error',
		title: 'Error',
		text: 'Oops! Something went wrong. Please try again.',
	});
};

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
